import React from "react";
import { Button } from "react-bootstrap";

const EnquireButton = ({ handleShow, currentPackage }) => {
  return (
    <div className="mt-3 mb-5">
      <Button
        className="btn-custom w-100 text-uppercase"
        onClick={() => handleShow()}
      >
        {/*Call Now (1300 872 835)*/}
        Enquire Now
      </Button>
    </div>
  );
};

export default EnquireButton;
